import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { host } from '../../function/api'

const initialState = {
   
    Agentperson: [],
    Agentsuccess: false,
    Agentstatus: false,
    Agentloading: '',
    Agentmessage: '',
    AgenterrorName: '',
    AgenterrorMobile: '',
    AgenterrorCity: '',
    AgenterrorFlag: '',
    AgenterrorPassword: ''
}



export const AgentuserUpdate = createAsyncThunk(
    'user/update',
    async (data, thunkAPI) => {
        try {
            console.log(data)
            const response = await axios({
                method: 'PATCH',
                url: `${host}user/${data.id}`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)




export const AgentfetchUser = createAsyncThunk(
    'fetch/user',
    async (user, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}user/${user}`,
                data: user,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

const AgentManagment = createSlice({
    name: 'AgentManagment',
    initialState,
    reducers: {

    },
    extraReducers: {
       

        
        [AgentuserUpdate.fulfilled]: (state, { payload }) => {
            state.Agentloading = false;
            state.Agentsuccess = true;
            state.Agentstatus = true
            state.Agentmessage = payload.message;
        },
        [AgentuserUpdate.pending]: (state) => {
            state.Agentloading = true;
            state.Agentstatus = false
            state.Agentsuccess = false;
            state.AgenterrorName = ''
            state.AgenterrorMobile = ''
            state.AgenterrorFlag = ''
            state.AgenterrorPassword = ''
        },
        [AgentuserUpdate.rejected]: (state, { payload }) => {
            state.Agentloading = false;
            state.Agentsuccess = false;
            state.Agentstatus = false
            state.Agentmessage = payload.response.data.message;
            if (payload.response.data.error) {
                state.AgenterrorName = payload.response.data.error.name
                state.AgenterrorMobile = payload.response.data.error.mobile
                state.AgenterrorFlag = payload.response.data.error.flag
                state.AgenterrorPassword = payload.response.data.error.password
            } else {
                state.AgenterrorName = ''
                state.AgenterrorMobile = ''
                state.AgenterrorFlag = ''
                state.AgenterrorPassword = ''
            }
        },



        [AgentfetchUser.fulfilled]: (state, action) => {
            state.Agentloading = false;
            state.Agentsuccess = true;
            state.Agentstatus = true,
            state.Agentperson = action.payload.data
            state.Agentmessage = action.payload.message
        },
        [AgentfetchUser.pending]: (state) => {
            state.Agentloading = true;
            state.Agentsuccess = false;
            state.Agentstatus = false
            state.Agentperson = [];
        },
        [AgentfetchUser.rejected]: (state, { payload }) => {
            state.Agentloading = false;
            state.Agentsuccess = false;
            state.Agentstatus = false
            state.Agentmessage = payload.response.data.message
        }

      
    }
})

export const { } = AgentManagment.actions;
export default AgentManagment.reducer;